import { Stack, Grid2 as Grid } from '@mui/material';

import { useTranslate } from 'src/locales';
import { ConnectionButton, ChannelStepLayout } from 'src/pages/channel/shared';

import { Form, Field } from 'src/components/hook-form';

import { useMessengerStep2 } from '../hooks';

export function FaceBookStep2() {
  const { t } = useTranslate('translation');
  const { methods, channelName, isFormValid, isWhatsappConnectSuccess, connect, onSubmit } =
    useMessengerStep2();

  return (
    <Stack spacing={4} sx={{ height: '100%' }}>
      <Form methods={methods} onSubmit={onSubmit}>
        <ChannelStepLayout title="" isNextDisabled={!isFormValid || !isWhatsappConnectSuccess}>
          {/* Form Content */}
          <Grid container spacing={3}>
            <Grid size={{ xs: 12 }}>
              <Field.Text
                name="channelName"
                label={t('CHANNEL_NAME')}
                InputLabelProps={{ shrink: true }}
                placeholder={t('ENTER_CHANNEL_NAME_PLACEHOLDER')}
              />
            </Grid>

            {/* Connect Button Section */}
            <Grid size={{ xs: 12 }}>
              <Stack spacing={2}>
                <ConnectionButton
                  label={`${t('SIGN_IN_WITH')} ${t('FACEBOOK')}`}
                  icon="ic:round-facebook"
                  onClick={connect}
                  disabled={!channelName}
                  isConnected={isWhatsappConnectSuccess}
                  successMessage={t('ACCOUNT_VERIFIED')}
                />
              </Stack>
            </Grid>
          </Grid>
        </ChannelStepLayout>
      </Form>
    </Stack>
  );
}
